/**
 * Order helpers for the procurement-workflow redesign: building an Order
 * from an accepted Offer, and the per-item / overall status gates.
 */

export const buildOrderFromOffer = (offer = {}) => ({
  items: (offer.items || []).map((item, index) => ({
    id: `${offer.id}-order-item-${index + 1}`,
    lineType: item.lineType || 'Product',
    serviceId: item.serviceId ?? null,
    logisticsId: item.logisticsId ?? null,
    linkedToLineId: item.linkedToLineId ?? null,
    productName: item.productName,
    quantity: item.quantity ?? item.qty,
    supplierName: item.supplierName || '',
    confirmedUnitPrice: Number(item.unitPrice || 0),
    setupCost: Number(item.setupCost || 0),
    handlingCost: Number(item.handlingCost || 0),
    shipmentCost: Number(item.shipmentCost || 0),
    otherCosts: Number(item.otherCosts || 0),
    marginPercent: Number(item.marginPercent || 0),
    discountPercent: Number(item.discountPercent || 0),
    deliveryDate: item.deliveryDate || null,
    countryOfProduction: item.countryOfProduction || '',
    fulfilmentStatus: 'Production',
    sourceOfferId: offer.id,
    sourceOfferItemId: item.id,
  })),
});

export const allItemsAccepted = (order = {}) => (
  (order.items || []).length > 0
  && (order.items || []).every((item) => item.fulfilmentStatus === 'Accepted by Customer')
);

export const canEditOrderItem = (order = {}) => order.overallStatus === 'In Progress';
